import React from "react";

/** Centralized role meta — labels + colors used across the app. */
export const ROLE_META = {
  master: {
    label: "Master",
    short: "M",
    description: "Eigentümer · sieht alles",
    bg: "bg-prime",
    bgSoft: "bg-prime/10",
    text: "text-prime",
    border: "border-prime",
    ring: "ring-prime",
    hex: "#DC1F2C",
  },
  admin: {
    label: "Admin",
    short: "A",
    description: "Administrator · genehmigt Dossiers",
    bg: "bg-rose-700",
    bgSoft: "bg-rose-100",
    text: "text-rose-700",
    border: "border-rose-700",
    ring: "ring-rose-700",
    hex: "#BE123C",
  },
  control: {
    label: "Mit Finma",
    short: "F+",
    description: "Berater mit FINMA-Registrierung · genehmigt Dossiers",
    bg: "bg-amber-500",
    bgSoft: "bg-amber-100",
    text: "text-amber-700",
    border: "border-amber-500",
    ring: "ring-amber-500",
    hex: "#F59E0B",
  },
  basic: {
    label: "Ohne Finma",
    short: "F−",
    description: "Berater ohne FINMA-Registrierung",
    bg: "bg-blue-600",
    bgSoft: "bg-blue-100",
    text: "text-blue-700",
    border: "border-blue-600",
    ring: "ring-blue-600",
    hex: "#2563EB",
  },
  finanza: {
    label: "Finanzen",
    short: "F",
    description: "Nur Zahlen · kein Kundenzugriff",
    bg: "bg-violet-600",
    bgSoft: "bg-violet-100",
    text: "text-violet-700",
    border: "border-violet-600",
    ring: "ring-violet-600",
    hex: "#7C3AED",
  },
};

// Legacy normalization (used by security/permissions checks). `admin` stays as
// admin for *display* (via getRoleMeta below) but is treated as master-tier in
// _owner_filter / _role_normalized on the backend.
const LEGACY_MAP = { consultant: "basic" };

export function normalizeRole(role) {
  return LEGACY_MAP[role] || role || "basic";
}

export function getRoleMeta(role) {
  // If the raw role has its own meta entry, use it directly (so legacy "admin"
  // renders as "Admin" instead of being folded into "Master").
  if (role && ROLE_META[role]) return ROLE_META[role];
  return ROLE_META[normalizeRole(role)] || ROLE_META.basic;
}

/** Small pill showing role label in its color. */
export default function RoleBadge({ role, size = "sm", className = "" }) {
  const meta = getRoleMeta(role);
  const sz = size === "xs" ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 font-bold uppercase tracking-wider rounded ${meta.bgSoft} ${meta.text} ${sz} ${className}`}
      data-testid={`role-badge-${normalizeRole(role)}`}
    >
      <span className={`inline-block w-1.5 h-1.5 rounded-full ${meta.bg}`} />
      {meta.label}
    </span>
  );
}
